


































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
import LetterTabVue from "../components/LetterTab.vue";
@Component({
    ...mapGetters(["account", "searchKey"]),
    components: {
        "letter-tab": LetterTabVue,
    }
})
export default class Performance extends Vue {
    isTop: string = "110px"  //侧边栏高度
    searchKey: string = "";
    endPeriod: string = "";
    dateTime: Date = new Date();
    // 分页
    currentPage: number = 1;
    pageSize: number = 13;
    totalElements: number = 0;
    mounted() {
        this.dateTime = new Date(this.$store.state.collectPeriod.substr(0, 4) + "-" + this.$store.state.collectPeriod.substr(4));
        // Date
        this.endPeriod = this.$utils.simpleDateFormat(new Date(this.dateTime), "m")
        this.fetchData()
    }
    // 获取时间范围
    get disabledDate() {
        return {
            disabledDate: (time: Date) => {
                let endTime = new Date(this.$store.state.collectPeriod.substr(0, 4) + "-" + this.$store.state.collectPeriod.substr(4));
                let end: Date = endTime;
                return time.getTime() > end.getTime();
            }
        }
    };
    // 选择时间
    changeDate(val: Date) {
        this.endPeriod = this.$utils.simpleDateFormat(val, "m");
        this.fetchData()
    }
    // 表格数据
    tableDate: Achievements.Achievements[] = []
    fetchData() {
        Vue.axios.post(
            `performances/find?page=${this.currentPage - 1}&size=${this.pageSize}`, {
                accounterNo: this.$store.state.account.no,
                searchKey: this.searchKey,
                endPeriod: this.endPeriod,
                query: this.$store.state.searchKey,
            })
            .then(res => {
                this.tableDate = res.data.content
                this.totalElements = res.data.totalElements
            });
    }
    // 分页切换
    changePage(val: number) {
        this.currentPage = val;
        this.fetchData();
    }
}
